import { List, Modal, Toast } from "antd-mobile";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import PsContext from "../../context";
import { _OpenPayment, _OpenPaymentFees } from "../../models/pay";
import { formToObject } from "../../utils";

const NewPayment = (props) => {
  const context = useContext(PsContext);
  const [unpaid, setUnpaid] = useState([]);

  const [student, setStudent] = useState(props.student);
  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);
  const [response, setReponse] = useState([]);

  useEffect(() => {
    loadUnPaid();
  }, []);

  const loadUnPaid = () => {
    setLoader(true);
    context.setLoader(true);
    _OpenPaymentFees({
      uuid: student.uuid,
      id: student.id,
    }).then((res) => {
      if (res.status == "1") {
        setUnpaid(res.data);
      }
      context.setLoader(false);
      setLoader(false);
    });
  };

  const getTotal = () => {
    let total = 0;
    unpaid.map(
      (item) => (total = parseFloat(total) + parseFloat(item.fee_amount))
    );
    return parseFloat(total).toFixed(2);
  };

  const PayNowClick = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    Modal.confirm({
      title: "Do you want to pay ?",
      confirmText: "Yes, Pay Now",
      cancelText: "Cancel",
      onConfirm: () => confirmPayment(formToObject(form)),
    });
  };

  const confirmPayment = (form) => {
    context.setLoader(true);
    _OpenPayment(form).then((res) => {
      if (res.status == "1") {
        setReponse(res.data);
      } else {
        Toast.show({ content: res.message || "Error on payment" });
      }
      context.setLoader(false);
    });
  };

  useEffect(() => {
    if (response && response.access_code)
      document.getElementById("redirect").submit();
  }, [response]);

  return (
    <>
      {!loader && unpaid.length < 1 && (
        <h5 className="py-5 fw-bold text-center" data-aos="zoom-in">
          No outstanding dues
        </h5>
      )}

      {!loader && unpaid.length > 0 && (
        <div data-aos="zoom-in">
          <Form
            method="post"
            noValidate
            validated={validated}
            onSubmit={PayNowClick}
          >
            <List>
              {unpaid.map((item, i) => {
                return (
                  <List.Item extra={item.fee_amount}>
                    {item.category_name}
                  </List.Item>
                );
              })}
              <List.Item extra={<b>Rs. {getTotal()}</b>}>Total</List.Item>
            </List>
            <Row className="mt-2">
              <Col md={12}>
                <Form.Control
                  type="number"
                  name="mobile"
                  required
                  size="md"
                  className="fw-bold"
                  placeholder="Student Mobile Number"
                />
              </Col>
            </Row>
            <Row className="mt-2">
              <Col md={12}>
                <Form.Control
                  type="email"
                  name="email"
                  required
                  size="md"
                  className="fw-bold"
                  placeholder="Student Mail Id"
                />
              </Col>
            </Row>
            <input type="hidden" name="data" value={JSON.stringify(unpaid)} />
            <input type="hidden" name="uuid" value={student.uuid} />
            <input type="hidden" name="id" value={student.id} />
            <Row className="mt-3">
              <Col className="text-center">
                <Button type="submit" className="w-100">
                  Pay Now
                </Button>
              </Col>
            </Row>
          </Form>
        </div>
      )}

      {response && response.access_code && (
        <form
          method="post"
          name="redirect"
          id="redirect"
          action="https://secure.ccavenue.com/transaction/transaction.do?command=initiateTransaction"
        >
          <input type="hidden" name="encRequest" value={response.reqdata} />
          <input
            type="hidden"
            name="access_code"
            value={response.access_code}
          />
        </form>
      )}
    </>
  );
};
export default NewPayment;
